import { render, staticRenderFns } from "./PersonWill.vue?vue&type=template&id=bddc031c"
import script from "./PersonWill.vue?vue&type=script&lang=js"
export * from "./PersonWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports